import React from 'react';
import styles from './index.less';

const MessageLeadsPhone = () => {
  return (
    <div className={styles['leads-phone-card']}>
      <div className={styles['leads-phone-text']}>您可以留下联系方式，我们将尽快与您联系</div>
      <div className={styles['leads-phone-action']}>一键发送抖音绑定手机号</div>
    </div>
  );
};

export default MessageLeadsPhone;
